export default "__VITE_ASSET__LqbA2WX___"